/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import styles from './HeadingWithLinks.module.scss';

/**
 * A Heading with some links
 */
export default function HeadingWithLinks({
  className = null,
  heading = null,
  items = null,
  type = 'header',
}) {
  const classNames = [
    styles['heading-with-links'],
    type === 'footer' && styles['heading-with-links--footer'],
    className,
  ].join(' ');

  const headingClassNames = [
    styles['heading-with-links__heading'],
    type === 'footer' && styles['heading-with-links__heading--footer'],
  ].join(' ');
  return (
    <div className={classNames}>
      <div className={headingClassNames}>{heading}</div>
      <ul>
        {items && items.map((item, index) => (
          <li key={index}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}

HeadingWithLinks.propTypes = {
  /**
   * Class name to apply to object
   */
  className: PropTypes.string,
  /**
   * Heading
   */
  heading: PropTypes.string,
  /**
   * Array of Links
   */
  items: PropTypes.arrayOf(PropTypes.node),
  /**
   * Type of links
   */
  type: PropTypes.oneOf(['footer', 'header']),
};

HeadingWithLinks.styles = {
  icon: styles['heading-with-links__icon'],
  iconFill: styles['--fill'],
  iconFillAndStroke: styles['--fill-and-stroke'],
};
